
const { regClass, property } = Laya;

@regClass('c5PJA3D7QFWceCozZH9ukw')
export default class ToyStyle {

    public skin_id: number = -1; // 皮肤id
    public mat_id : number = -1; // 材质id


    constructor(skin_id:number = -1, mat_id:number = -1) {
        this.skin_id = skin_id;
        this.mat_id = mat_id;
    }
}